module.exports = __webpack_public_path__ + "static/media/Acrilico (33).a1ea3ce6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (33).jpg
// module id = 301
// module chunks = 0